import {
    IonIcon,
    useIonActionSheet,
    IonNote,
    IonText,
    IonBadge,
    IonButton
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    eye,
    receipt,
    chevronDownCircleOutline,
    chevronUpCircleOutline,
    waterOutline,
    flashOutline
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { colorTheme } from '../../utils/constants';

// All actions
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';
const A_CREATE_INVOICE = 'Create Invoice';
const A_VIEW_INVOICE = 'View Invoice';


const UtilityListItem = ({
  utilityId, unitName, propertyName, showDetails, utilityItem,
  utility, handleUnitUtilityAction, invoiceId, userAllPerms
 }) => {
    const defaultUtility = { item: "", previousReading: 0, currentReading: 0, date: null, invoiceAmount: 0 };
    const {
      item, previousReading, currentReading, date, invoiceAmount
    } = {...defaultUtility, ...utility};
    const [showExtraDetails, setShowExtraDetails] = useState(false);

    const [present] = useIonActionSheet();
    const [extraData, setExtraData] = useState([
      { label: "Item", value: utilityItem },
      { label: "Previous Reading", value: previousReading },
      { label: "Current Reading", value: currentReading },
      { label: "Property", value: propertyName },
      { label: "Unit", value: unitName },
      { label: "Date", value: date },
      { label: "Utility Id/Number", value: utilityId },
    ]);

    const actionsRequiringAllUtilityPerms = [A_EDIT, A_DELETE];
    const actionsRequiringAllInvoicePerms = [A_CREATE_INVOICE, A_VIEW_INVOICE];


    const open = async () => {
        const mode = getMode();
        const buttons = [{
          text: A_EDIT,
          role: 'destructive',
          icon: mode !== 'ios' ? pencil : '',
          handler: () => {
            handleUnitUtilityAction('edit', utilityId);
          }
        },
        {
          text: !invoiceId? A_CREATE_INVOICE : A_VIEW_INVOICE,
          icon: !invoiceId? mode !== 'ios' ? receipt : '' : mode !== 'ios' ? eye : '',
          handler: () => {
            if (!invoiceId) {
              handleUnitUtilityAction('create-invoice', utilityId);
            } else {
              handleUnitUtilityAction('view-invoice', invoiceId);
            }
          }

        }, {
          text: A_DELETE,
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handleUnitUtilityAction('delete', utilityId);
          }
        }, {
          text: A_CANCEL,
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        let filteredButtons = buttons;
        if(!userAllPerms.utility){
          filteredButtons = filteredButtons.filter(button => !actionsRequiringAllUtilityPerms.includes(button.text));
        }
        if(!userAllPerms.invoice){
          filteredButtons = filteredButtons.filter(button => !actionsRequiringAllInvoicePerms.includes(button.text));
        }

        present({
          header: item + "  " + currentReading + " | " + unitName + " " + propertyName,
          buttons: filteredButtons
        });
      }

    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])

    return (
      <div className='mx-1 mx-md-4' key={utilityId} >
        <Row className='px-0 mx-0 my-2 py-1 shadow-sm rounded'>
          <Row className='rounded mx-0 px-0' 
          >
            <Col className='pr-1' onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={7} md={6}>
              <Row>
              <Col xs={12} md={5}>
                <IonIcon
                  style={{fontSize: '25px', color: 'var(--ion-color-primary)'}}
                  icon={utilityItem == "water"? waterOutline : flashOutline}
                ></IonIcon>
                &nbsp;
                
                <strong>{utilityItem} &nbsp; 
                  <IonIcon
                    style={{fontSize: '18px', color: 'var(--ion-color-primary)'}}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
              </strong>

                </Col>
              <Col xs={12} md={5}>
                <IonNote >
                  {unitName}{(unitName && propertyName)? " | ": ""}
                </IonNote> &nbsp; 
                <IonNote className='text-sm'>
                  {propertyName}
                </IonNote>
              </Col>
              </Row>
            </Col>

            <Col xs={4} md={5} className='px-0 mx-0'>
              <Row className='px-0 mx-0 d-flex justify-content-md-end justify-content-sm-start'>
              <Col className='px-0 mx-0' xs={12} md={6}> 
                <IonText><strong>{currentReading}</strong></IonText> 
                &nbsp;
                <IonBadge color="light">
                  <IonNote className='text-sm'>units</IonNote>
                </IonBadge>
              </Col>
              <Col className='px-0 mx-0' xs={12} md={6}>
                <IonNote>{date}</IonNote>
              </Col>
              </Row>
            </Col>

            <div style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div> 
          </Row>          

            {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"] }} className='mx-2 mr-3 mb-2 py-3 rounded tenant-list-row'>
              <Row>
                <IonButton 
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  Options
                </IonButton>
              </Row>
              { extraData.map((data, index) => (
                <Row key={index} className='border-bottom my-1'>
                  <Col  xs={5} md={3}><strong>{data.label}</strong></Col>
                  <Col xs={7} md={8}>
                    <span style={{fontSize: '16px'}}>{data.value}</span>
                  </Col>
                </Row>
              ))}
            </Row>)}
            </Row>
      </div>
    );
}

export default UtilityListItem;